import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Breadcrumb } from '@app/models/_base/breadcrumb.model';
import { Footer } from '@app/services/footer.service';
import { LocalisationService } from '@app/services/localisation.service';
import { QuestionnaireService } from '@app/services/questionnaire.service';
import { RouteBreadcrumbs } from '@app/services/routeBreadcrumbs.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  public static route: string = 'centigrade';

  locale: any = {};
  menuOpen: boolean = false;
  showFooter: boolean = true;
  breadcrumbs: Breadcrumb[];
  disableBackButton: boolean;
  title: string;
  action: (() => void) | string;
  actionIsPath: boolean = false;
  centreComponent: boolean = false;
  externalLink: boolean = false;
  alignLeft: boolean = false;

  private breadcrumbSubscription: Subscription;
  private footerSubscription: Subscription;
  private disableBackButtonSubscription: Subscription;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private routeBreadcrumbs: RouteBreadcrumbs,
    private footerService: Footer,
    private router: Router,
    private questionnaireService: QuestionnaireService,
    private localisation: LocalisationService
  ) {}

  ngOnInit() {
    this.localisation.centreComponent.subscribe(
      centreComponent => (this.centreComponent = centreComponent)
    );

    if (this.router.url == '/centigrade/questions') {
      this.localisation.updateCentreComponent(true);
    }

    this.locale = this.localisation.getTranslationsForComponent('MainNavComponent');
    this.breadcrumbSubscription = this.routeBreadcrumbs.breadcrumbs.subscribe(breadcrumbs => {
      this.breadcrumbs = breadcrumbs;
      this.changeDetectorRef.detectChanges();
    });

    this.disableBackButtonSubscription = this.routeBreadcrumbs.disableBackButton.subscribe(
      disable => {
        this.disableBackButton = disable;
        this.changeDetectorRef.detectChanges();
      }
    );

    this.footerSubscription = this.footerService.onUpdated.subscribe(options => {
      if (!options) options = { title: null, action: null };

      this.title = options.title;
      this.action = options.action;
      this.externalLink = options.externalLink;
      this.alignLeft = options.alignLeft;

      if (typeof options.action == 'string') {
        this.actionIsPath = true;
      } else {
        this.actionIsPath = false;
      }

      this.showFooter = !!this.title;

      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy() {
    if (this.breadcrumbSubscription) this.breadcrumbSubscription.unsubscribe();

    if (this.disableBackButtonSubscription) this.disableBackButtonSubscription.unsubscribe();

    if (this.footerSubscription) this.footerSubscription.unsubscribe();
  }

  actionClicked() {
    this.footerService.onActionClicked.next();
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu() {
    this.menuOpen = false;
  }

  goToHome() {
    this.questionnaireService.getCurrentQuestionnaire().subscribe(res => {
      if (res.status >= 100) this.router.navigateByUrl('/centigrade/course-areas');
      else this.router.navigateByUrl('/centigrade/questions');
    });
  }

  goToLink(url) {
    window.location.href = url;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/_shared/main-layout/main-layout.component.ts